import React from 'react'
import { Header, Icon, Table, Form, Button } from 'semantic-ui-react'

const PassportFideliteSubscribers = ({ passportFideliteSubscribers, onDelete }) => {
  if (!passportFideliteSubscribers || passportFideliteSubscribers.length === 0) {
    return (
      <div>
        <Header as="h1">Inscrits au Passeport Fidélité</Header>
        <br />
        Aucun enregistrement
      </div>
    )
  }

  return (
    <div>
      <Header as="h1">Inscrits au Passeport Fidélité</Header>
      <Table selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Date première inscription</Table.HeaderCell>
            <Table.HeaderCell>Date dernière inscription</Table.HeaderCell>
            <Table.HeaderCell>Nombre d'inscription</Table.HeaderCell>
            <Table.HeaderCell textAlign="right">Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {passportFideliteSubscribers.map(passportFideliteSubscriber => {
            return (
              <Table.Row key={passportFideliteSubscriber.id}>
                <Table.Cell>{passportFideliteSubscriber.email}</Table.Cell>
                <Table.Cell>{passportFideliteSubscriber.created_at}</Table.Cell>
                <Table.Cell>{passportFideliteSubscriber.updated_at}</Table.Cell>
                <Table.Cell>{passportFideliteSubscriber.count}</Table.Cell>
                <Table.Cell textAlign="right">
                  <Form>
                    <div>
                      <Button
                        type="submit"
                        color="red"
                        floated="right"
                        className="button-icon"
                        onClick={(event, data) => {
                          onDelete(event, { confirm: false, id: passportFideliteSubscriber.id })
                        }}
                      >
                        <Icon name="delete" />
                      </Button>
                    </div>
                  </Form>
                </Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="5">
              <a href={`${process.env.REACT_APP_API_URL}/passportfidelite-subscribers.csv`}>
                <Icon name="download" /> Télécharger les abonnés au format CSV
              </a>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  )
}

export default PassportFideliteSubscribers



// WEBPACK FOOTER //
// ./src/components/list/PassportFideliteSubscribers.js